import React from 'react';

import { useTranslation } from 'react-i18next';

interface PdfArtifactCardProps {
  url: string;
  fileName?: string;
}

export const PdfArtifactCard: React.FC<PdfArtifactCardProps> = ({
  url,
  fileName = 'document.pdf',
}) => {
  const { t } = useTranslation('pleri/chat');
  return (
    <a
      href={url}
      download={fileName}
      className="group mt-2 flex w-full max-w-sm items-center gap-3 rounded-2xl border border-gray-200 bg-white px-4 py-3 shadow-sm transition-all duration-150 hover:border-gray-300 hover:shadow-md dark:border-gray-700 dark:bg-gray-900 dark:hover:border-gray-600"
      title={t('downloadPdf')}
    >
      {/* Neutral gray icon — never looks like an error */}
      <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl bg-gray-100 dark:bg-gray-800">
        <svg className="h-5 w-5 text-gray-500 dark:text-gray-400" fill="none" viewBox="0 0 24 24" strokeWidth="1.75" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
        </svg>
      </div>
      <div className="min-w-0 flex-1">
        <div className="truncate text-sm font-semibold text-gray-800 dark:text-gray-100">{fileName}</div>
        <div className="mt-0.5 flex items-center gap-1.5">
          <span className="text-xs font-medium text-gray-400 dark:text-gray-500">PDF</span>
          <span className="text-xs text-gray-300 dark:text-gray-600">·</span>
          <span className="text-xs text-gray-400 dark:text-gray-500">{t('clickToDownload')}</span>
        </div>
      </div>
      {/* Download arrow — distinct from open arrow */}
      <svg
        className="h-4 w-4 flex-shrink-0 text-gray-300 transition-all duration-150 group-hover:translate-y-0.5 group-hover:text-gray-500 dark:text-gray-600 dark:group-hover:text-gray-400"
        fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor"
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3" />
      </svg>
    </a>
  );
};
